export const USER = {
	FIRST_NAME: '{{user.firstName}}',
	LAST_NAME: '{{user.lastName}}',
	PHONE: '{{user.phoneNumber}}',
	EMAIL: '{{user.email}}',
	BUSINESS_NAME: '{{user.businessName}}',

	SYSTEM_NAME: '{{user.systemName}}',
	MC: '{{user.mc}}',
};

export const CARRIER = {
	BUSINESS_NAME: '{{carrier.businessName}}',
	MC: '{{carrier.mc}}',
	DOT: '{{carrier.dot}}',
};

export const OFFER_LINK = '{{c4BaseUrl}}/#/bid/monitor/{{bid.id}}';
export const BATCH_OFFER_LINK =
	'{{c4BaseUrl}}/#/loadsSourcing/{{bid.carrierId}}?batchId={{batchId}}&accountId={{encodedAccountId}}';

export const QUOTE = {
	REFERENCE_NUMBER: '{{quote.referenceNumber}}',
	ORIGIN_CITY: '{{quote.originCity}}',
	ORIGIN_STATE: '{{quote.originState}}',
	DESTINATION_CITY: '{{quote.destinationCity}}',
	DESTINATION_STATE: '{{quote.destinationState}}',
	EQUIPMENTS: '{{quoteEquipments}}',
	PICKUP_DATE: '{{quotePickupDate}}',
	WEIGHT: '{{quoteWeight}}',
	DECLARED_PRICE: '{{quoteDeclaredPrice}}',
	TRAILER_LENGTH: '{{quote.trailerLength}}',
	STOPS: '{{quote.stopsCount}}',
	TEAM_SERVICE_REQUIRED: '{{quote.teamServiceRequired}}',
	PIECES: '{{quote.pieces}}',
	PARTIAL_LOAD: '{{quote.partialLoad}}',
	LINEAR_FEET: '{{quote.linearFeet}}',

	ORIGIN_POSTCODE: '{{quote.originPostcode}}',
	DESTINATION_POSTCODE: '{{quote.destinationPostcode}}',
	APPROXIMATTE_MILES: '{{quoteApproximateMiles}}',
	COMMODITY: '{{quote.commodity}}',
	PICKUP_OPEN_TIME: '{{quotePickupOpenTime}}',
	PICKUP_CLOSE_TIME: '{{quotePickupCloseTime}}',
	DELIVERY_DATE: '{{quoteDeliveryDate}}',
	DELIVERY_OPEN_TIME: '{{quoteDeliveryOpenTime}}',
	DELIVERY_CLOSE_TIME: '{{quoteDeliveryCloseTime}}',
	TARP_SIZE: '{{quote.tarpSize}}',
	SPECIAL_INSTRUCTIONS: '{{quote.specialInstructions}}',
	PICKUP_APPOINTMENT_REQUIRED: '{{quote.pickupAppointmentRequired}}',
	DELIVERY_APPOINTMENT_REQUIRED: '{{quote.deliveryAppointmentRequired}}',
	PO_NUMBER: '{{quote.poNumber}}',
	ORDER_TYPE: '{{quote.orderType}}',

	TEMPERATURE: '{{quoteTemperature}}',
	MIN_TEMPERATURE: '{{quoteMinTemperature}}',
	MAX_TEMPERATURE: '{{quoteMaxTemperature}}',
	DECLARED_VALUE: '{{quoteDeclaredValue}}',
};

export const BID = {
	AMOUNT: '{{bidAmount}}',
	PICKUP_DATE: '{{bidPickupDate}}',
	DELIVERY_DATE: '{{bidDeliveryDate}}',
};

export const COUNTER_OFFER = {
	OFFER_AMOUNT: '{{this.counterOfferAmount}}',
	PICKUP_DATE: '{{this.counterOfferPickupDate}}',
	DELIVERY_DATE: '{{this.counterOfferDeliveryDate}}',
};

export const PROJECT = {
	EQUIPMENT_TYPE: '{{projectDTO.equipmentType}}',
	ORIGIN_CITY: '{{projectDTO.originCity}}',
	ORIGIN_STATE: '{{projectDTO.originState}}',
	DESTINATION_CITY: '{{projectDTO.destCity}}',
	DESTINATION_STATE: '{{projectDTO.destState}}',
	COMMODITY: '{{projectDTO.commodity}}',
	TRAILER_REQUIREMENTS: '{{projectDTO.trailerRequirements}}',
	DUE_DATE: '{{dueDate}}',
	SHIPPER_NOTES: '{{projectDTO.shipperNotes}}',
	RECEIVER_NOTES: '{{projectDTO.receiverNotes}}',
	WEIGHT: '{{projectWeight}}',
	PACKAGING: '{{projectDTO.packaging}}',
	NAME: '{{projectDTO.name}}',
};

export const ANNUAL_VOLUME_VALUE = '{{annualVolumeValue}}';

export const LATEST_CARRIER_AMOUNT = '{{latestCarrierAmount}}';

export const TEMPLATE_TYPE = {
	LOAD_OFFER: 'loadOffer',
	LOAD_OFFER_AUTOMATED: 'loadOfferAutomated',
	LOAD_OFFER_BATCH: 'loadOfferBatch',
	COUNTER_OFFER: 'counterOffer',
	ACCEPT_OFFER: 'acceptOffer',
	CHECK_CAPACITY: 'checkCapacity',
	EMAIL_SIGNATURE: 'emailSignature',
	PROCURED_CARRIER: 'procuredCarrier',
};

export const TEMPLATE_TYPE_DISPLAY_NAME = {
	loadOffer: 'Load Offer',
	loadOfferAutomated: 'Load Offer (Automated Booking)',
	loadOfferBatchL: 'Load Offer (Batch)',
	counterOffer: 'Counter Offer',
	acceptOffer: 'Accept Offer',
	checkCapacity: 'Check Capacity',
	procuredCarrier: 'Procured Carrier',
	emailSignature: 'Email Signature',
};

export const REQUIRED_FIELDS = {
	LOAD_OFFER: [
		{ 'Origin City': '{{[\\n\\r\\s]*quote.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*quote.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*quote.destinationCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*quote.destinationState[\\n\\r\\s]*}}' },
		{ 'Trailer Type': '{{[\\n\\r\\s]*quoteEquipments[\\n\\r\\s]*}}' },
		{ 'Pickup Date': '{{[\\n\\r\\s]*bidPickupDate[\\n\\r\\s]*}}' },
	],
	LOAD_OFFER_AUTOMATED: [
		{ 'Origin City': '{{[\\n\\r\\s]*quote.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*quote.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*quote.destinationCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*quote.destinationState[\\n\\r\\s]*}}' },
		{ 'Trailer Type': '{{[\\n\\r\\s]*quoteEquipments[\\n\\r\\s]*}}' },
		{ 'Pickup Date': '{{[\\n\\r\\s]*bidPickupDate[\\n\\r\\s]*}}' },
		{
			'Offer Link':
				'{{[\\n\\r\\s]*c4BaseUrl[\\n\\r\\s]*}}/#/bid/monitor/{{[\\n\\r\\s]*bid.id[\\n\\r\\s]*}}',
		},
	],
	LOAD_OFFER_BATCH: [
		{ 'Origin City': '{{[\\n\\r\\s]*quote.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*quote.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*quote.destinationCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*quote.destinationState[\\n\\r\\s]*}}' },
		{ 'Trailer Type': '{{[\\n\\r\\s]*quoteEquipments[\\n\\r\\s]*}}' },
		{ 'Pickup Date': '{{[\\n\\r\\s]*bidPickupDate[\\n\\r\\s]*}}' },
	],
	COUNTER_OFFER: [
		{ 'Origin City': '{{[\\n\\r\\s]*quote.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*quote.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*quote.destinationCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*quote.destinationState[\\n\\r\\s]*}}' },
		{ 'Latest Carrier Amount': '{{[\\n\\r\\s]*latestCarrierAmount[\\n\\r\\s]*}}' },
		{ 'Trailer Type': '{{[\\n\\r\\s]*quoteEquipments[\\n\\r\\s]*}}' },
		{ 'Pickup Date': '{{[\\n\\r\\s]*bidPickupDate[\\n\\r\\s]*}}' },
		{ 'Delivery Date': '{{[\\n\\r\\s]*bidDeliveryDate[\\n\\r\\s]*}}' },
	],
	ACCEPT_OFFER: [
		{ 'Origin City': '{{[\\n\\r\\s]*quote.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*quote.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*quote.destinationCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*quote.destinationState[\\n\\r\\s]*}}' },
		{ 'Bid Amount': '{{[\\n\\r\\s]*bidAmount[\\n\\r\\s]*}}' },
		{ 'Trailer Type': '{{[\\n\\r\\s]*quoteEquipments[\\n\\r\\s]*}}' },
		{ 'Pickup Date': '{{[\\n\\r\\s]*bidPickupDate[\\n\\r\\s]*}}' },
		{ 'Delivery Date': '{{[\\n\\r\\s]*quoteDeliveryDate[\\n\\r\\s]*}}' },
	],
	CHECK_CAPACITY: [
		{ 'Origin City': '{{[\\n\\r\\s]*projectDTO.originCity[\\n\\r\\s]*}}' },
		{ 'Origin State': '{{[\\n\\r\\s]*projectDTO.originState[\\n\\r\\s]*}}' },
		{ 'Destination City': '{{[\\n\\r\\s]*projectDTO.destCity[\\n\\r\\s]*}}' },
		{ 'Destination State': '{{[\\n\\r\\s]*projectDTO.destState[\\n\\r\\s]*}}' },
		{ 'Equipment Type': '{{[\\n\\r\\s]*projectDTO.equipmentType[\\n\\r\\s]*}}' },
	],
	PROCURED_CARRIER: [],
};

export const MERGE_TAGS_LOAD_OFFER = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
		},
	},
	carrier: {
		name: 'Carrier',
		mergeTags: {
			carrier_business_name: {
				name: 'Business Name',
				value: CARRIER.BUSINESS_NAME,
				sample: 'XYZ Carrier',
			},
			carrier_mc: {
				name: 'MC',
				value: CARRIER.MC,
				sample: '123456',
			},
			carrier_dot: {
				name: 'DOT',
				value: CARRIER.DOT,
				sample: '123456',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
			hey_contact_first_name: {
				name: 'Hey First Name',
				value: '{{Hey contact.firstName}}',
				sample: 'Hey John',
			},
		},
	},
	quote: {
		name: 'Load',
		mergeTags: {
			quote_reference_number: {
				name: 'Reference Number',
				value: QUOTE.REFERENCE_NUMBER,
				sample: 'Ref123456',
			},
			quote_origin_city: {
				name: 'Origin City',
				value: QUOTE.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			quote_origin_state: {
				name: 'Origin State',
				value: QUOTE.ORIGIN_STATE,
				sample: 'California',
			},
			quote_origin_postcode: {
				name: 'Origin Postcode',
				value: QUOTE.ORIGIN_POSTCODE,
				sample: '12345',
			},
			quote_destination_city: {
				name: 'Destination City',
				value: QUOTE.DESTINATION_CITY,
				sample: 'Dallas',
			},
			quote_destination_state: {
				name: 'Destination State',
				value: QUOTE.DESTINATION_STATE,
				sample: 'Texas',
			},
			quote_destination_postcode: {
				name: 'Destination Postcode',
				value: QUOTE.DESTINATION_POSTCODE,
				sample: '12345',
			},
			quote_equipments: {
				name: 'Equipments',
				value: QUOTE.EQUIPMENTS,
				sample: 'Van',
			},
			quote_commodity: {
				name: 'Commodity',
				value: QUOTE.COMMODITY,
				sample: 'Apples',
			},
			quote_trailer_length: {
				name: 'Trailer Length',
				value: QUOTE.TRAILER_LENGTH,
				sample: '(53 ft)',
			},
			quote_min_temperature: {
				name: 'Min Temperature',
				value: QUOTE.MIN_TEMPERATURE,
				sample: '45',
			},
			quote_max_temperature: {
				name: 'Max Temperature',
				value: QUOTE.MAX_TEMPERATURE,
				sample: '90',
			},
			quote_temperature: {
				name: 'Temperature',
				value: QUOTE.TEMPERATURE,
				sample: '45° F to 90° F',
			},
			quote_tarp_size: {
				name: 'Tarp Size',
				value: QUOTE.TARP_SIZE,
				sample: '8',
			},
			quote_declared_value: {
				name: 'Declared Value',
				value: QUOTE.DECLARED_VALUE,
				sample: '1234',
			},
			quote_pickup_date: {
				name: 'Pickup Date',
				value: QUOTE.PICKUP_DATE,
				sample: 'December 31',
			},
			quote_pickup_open_time: {
				name: 'Pickup Open Time',
				value: QUOTE.PICKUP_OPEN_TIME,
				sample: '08:00',
			},
			quote_pickup_close_time: {
				name: 'Pickup Close Time',
				value: QUOTE.PICKUP_CLOSE_TIME,
				sample: '20:00',
			},
			quote_pickup_time: {
				name: 'Pickup Time',
				value: '{{quotePickupTime}}',
				sample: '08:00 - 20:00',
			},
			quote_pickup_appointment_required: {
				name: 'Pickup Appointment Required',
				value: QUOTE.PICKUP_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_delivery_date: {
				name: 'Delivery Date',
				value: QUOTE.DELIVERY_DATE,
				sample: 'January 1',
			},
			quote_delivery_open_time: {
				name: 'Delivery Open Time',
				value: QUOTE.DELIVERY_OPEN_TIME,
				sample: '08:00',
			},
			quote_delivery_close_time: {
				name: 'Delivery Close Time',
				value: QUOTE.DELIVERY_CLOSE_TIME,
				sample: '20:00',
			},
			quote_delivery_time: {
				name: 'Delivery Time',
				value: '{{quoteDeliveryTime}}',
				sample: '08:00 - 20:00',
			},
			quote_delivery_appointment_required: {
				name: 'Delivery Appointment Required',
				value: QUOTE.DELIVERY_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_weight: {
				name: 'Weight',
				value: QUOTE.WEIGHT,
				sample: '123',
			},
			quote_declared_price: {
				name: 'Offer Price',
				value: QUOTE.DECLARED_PRICE,
				sample: '1234',
			},
			quote_stops: {
				name: 'Stops',
				value: QUOTE.STOPS,
				sample: '1',
			},
			quote_team_service_required: {
				name: 'Team Service Required',
				value: QUOTE.TEAM_SERVICE_REQUIRED,
				sample: 'Yes',
			},
			quote_special_instructions: {
				name: 'Special Instructions',
				value: QUOTE.SPECIAL_INSTRUCTIONS,
				sample: 'Handle with care',
			},
			quote_pieces: {
				name: 'Pieces',
				value: QUOTE.PIECES,
				sample: '2',
			},
			quote_partial_load: {
				name: 'Partial Load',
				value: QUOTE.PARTIAL_LOAD,
				sample: 'Yes',
			},
			quote_linear_feet: {
				name: 'Linear Feet',
				value: QUOTE.LINEAR_FEET,
				sample: '20',
			},
			quote_po_number: {
				name: 'PO Number',
				value: QUOTE.PO_NUMBER,
				sample: 'PO12345',
			},
			quote_order_type: {
				name: 'Order Type',
				value: QUOTE.ORDER_TYPE,
				sample: 'Outbound',
			},
		},
	},
	bid: {
		name: 'Bid',
		mergeTags: {
			bid_pickup_date: {
				name: 'Pickup Date',
				value: BID.PICKUP_DATE,
				sample: 'December 31',
			},
			bid_delivery_date: {
				name: 'Delivery Date',
				value: BID.DELIVERY_DATE,
				sample: 'January 1',
			},
		},
	},
	offer_link: {
		name: 'Offer Link',
		value: OFFER_LINK,
		sample: OFFER_LINK,
	},
	is_quote_temperature_available: {
		name: 'Is Quote Temperature Available',
		value: '{{isQuoteTemperatureAvailable}}',
		sample: 'true',
	},
	is_quote_declared_value_gt_threshold: {
		name: 'Is Declared Value Greater Than Threshold',
		value: '{{isQuoteDeclaredValueGtThreshold}}',
		sample: 'true',
	},
	is_quote_order_type_available: {
		name: 'Is Order Type Available',
		value: '{{isQuoteOrderTypeAvailable}}',
		sample: 'true',
	},
};

export const MERGE_TAGS_LOAD_OFFER_AUTOMATED = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
		},
	},
	carrier: {
		name: 'Carrier',
		mergeTags: {
			carrier_business_name: {
				name: 'Business Name',
				value: CARRIER.BUSINESS_NAME,
				sample: 'XYZ Carrier',
			},
			carrier_mc: {
				name: 'MC',
				value: CARRIER.MC,
				sample: '123456',
			},
			carrier_dot: {
				name: 'DOT',
				value: CARRIER.DOT,
				sample: '123456',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
			hey_contact_first_name: {
				name: 'Hey First Name',
				value: '{{Hey contact.firstName}}',
				sample: 'Hey John',
			},
		},
	},
	quote: {
		name: 'Load',
		mergeTags: {
			quote_reference_number: {
				name: 'Reference Number',
				value: QUOTE.REFERENCE_NUMBER,
				sample: 'Ref123456',
			},
			quote_origin_city: {
				name: 'Origin City',
				value: QUOTE.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			quote_origin_state: {
				name: 'Origin State',
				value: QUOTE.ORIGIN_STATE,
				sample: 'California',
			},
			quote_origin_postcode: {
				name: 'Origin Postcode',
				value: QUOTE.ORIGIN_POSTCODE,
				sample: '12345',
			},
			quote_destination_city: {
				name: 'Destination City',
				value: QUOTE.DESTINATION_CITY,
				sample: 'Dallas',
			},
			quote_destination_state: {
				name: 'Destination State',
				value: QUOTE.DESTINATION_STATE,
				sample: 'Texas',
			},
			quote_destination_postcode: {
				name: 'Destination Postcode',
				value: QUOTE.DESTINATION_POSTCODE,
				sample: '12345',
			},
			quote_equipments: {
				name: 'Equipments',
				value: QUOTE.EQUIPMENTS,
				sample: 'Van',
			},
			quote_commodity: {
				name: 'Commodity',
				value: QUOTE.COMMODITY,
				sample: 'Apples',
			},
			quote_trailer_length: {
				name: 'Trailer Length',
				value: QUOTE.TRAILER_LENGTH,
				sample: '(53 ft)',
			},
			quote_min_temperature: {
				name: 'Min Temperature',
				value: QUOTE.MIN_TEMPERATURE,
				sample: '45',
			},
			quote_max_temperature: {
				name: 'Max Temperature',
				value: QUOTE.MAX_TEMPERATURE,
				sample: '90',
			},
			quote_temperature: {
				name: 'Temperature',
				value: QUOTE.TEMPERATURE,
				sample: '45° F to 90° F',
			},
			quote_tarp_size: {
				name: 'Tarp Size',
				value: QUOTE.TARP_SIZE,
				sample: '8',
			},
			quote_declared_value: {
				name: 'Declared Value',
				value: QUOTE.DECLARED_VALUE,
				sample: '1234',
			},
			quote_pickup_date: {
				name: 'Pickup Date',
				value: QUOTE.PICKUP_DATE,
				sample: 'December 31',
			},
			quote_pickup_open_time: {
				name: 'Pickup Open Time',
				value: QUOTE.PICKUP_OPEN_TIME,
				sample: '08:00',
			},
			quote_pickup_close_time: {
				name: 'Pickup Close Time',
				value: QUOTE.PICKUP_CLOSE_TIME,
				sample: '20:00',
			},
			quote_pickup_time: {
				name: 'Pickup Time',
				value: '{{quotePickupTime}}',
				sample: '08:00 - 20:00',
			},
			quote_pickup_appointment_required: {
				name: 'Pickup Appointment Required',
				value: QUOTE.PICKUP_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_delivery_date: {
				name: 'Delivery Date',
				value: QUOTE.DELIVERY_DATE,
				sample: 'January 1',
			},
			quote_delivery_open_time: {
				name: 'Delivery Open Time',
				value: QUOTE.DELIVERY_OPEN_TIME,
				sample: '08:00',
			},
			quote_delivery_close_time: {
				name: 'Delivery Close Time',
				value: QUOTE.DELIVERY_CLOSE_TIME,
				sample: '20:00',
			},
			quote_delivery_time: {
				name: 'Delivery Time',
				value: '{{quoteDeliveryTime}}',
				sample: '08:00 - 20:00',
			},
			quote_delivery_appointment_required: {
				name: 'Delivery Appointment Required',
				value: QUOTE.DELIVERY_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_weight: {
				name: 'Weight',
				value: QUOTE.WEIGHT,
				sample: '123',
			},
			quote_declared_price: {
				name: 'Offer Price',
				value: QUOTE.DECLARED_PRICE,
				sample: '1234',
			},
			quote_stops: {
				name: 'Stops',
				value: QUOTE.STOPS,
				sample: '1',
			},
			quote_team_service_required: {
				name: 'Team Service Required',
				value: QUOTE.TEAM_SERVICE_REQUIRED,
				sample: 'Yes',
			},
			quote_special_instructions: {
				name: 'Special Instructions',
				value: QUOTE.SPECIAL_INSTRUCTIONS,
				sample: 'Handle with care',
			},
			quote_pieces: {
				name: 'Pieces',
				value: QUOTE.PIECES,
				sample: '2',
			},
			quote_partial_load: {
				name: 'Partial Load',
				value: QUOTE.PARTIAL_LOAD,
				sample: 'Yes',
			},
			quote_linear_feet: {
				name: 'Linear Feet',
				value: QUOTE.LINEAR_FEET,
				sample: '20',
			},
			quote_order_type: {
				name: 'Order Type',
				value: QUOTE.ORDER_TYPE,
				sample: 'Outbound',
			},
		},
	},
	bid: {
		name: 'Bid',
		mergeTags: {
			bid_pickup_date: {
				name: 'Pickup Date',
				value: BID.PICKUP_DATE,
				sample: 'December 31',
			},
			bid_delivery_date: {
				name: 'Delivery Date',
				value: BID.DELIVERY_DATE,
				sample: 'January 1',
			},
		},
	},
	offer_link: {
		name: 'Offer Link',
		value: OFFER_LINK,
		sample: OFFER_LINK,
	},
	is_quote_temperature_available: {
		name: 'Is Quote Temperature Available',
		value: '{{isQuoteTemperatureAvailable}}',
		sample: 'true',
	},
	is_quote_declared_value_gt_threshold: {
		name: 'Is Declared Value Greater Than Threshold',
		value: '{{isQuoteDeclaredValueGtThreshold}}',
		sample: 'true',
	},
	is_quote_order_type_available: {
		name: 'Is Order Type Available',
		value: '{{isQuoteOrderTypeAvailable}}',
		sample: 'true',
	},
};

export const MERGE_TAGS_LOAD_OFFER_BATCH = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
		},
	},
	carrier: {
		name: 'Carrier',
		mergeTags: {
			carrier_business_name: {
				name: 'Business Name',
				value: CARRIER.BUSINESS_NAME,
				sample: 'XYZ Carrier',
			},
			carrier_mc: {
				name: 'MC',
				value: CARRIER.MC,
				sample: '123456',
			},
			carrier_dot: {
				name: 'DOT',
				value: CARRIER.DOT,
				sample: '123456',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
			hey_contact_first_name: {
				name: 'Hey First Name',
				value: '{{Hey contact.firstName}}',
				sample: 'Hey John',
			},
		},
	},
	quote: {
		name: 'Load',
		mergeTags: {
			quote_origin_city: {
				name: 'Origin City',
				value: QUOTE.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			quote_origin_state: {
				name: 'Origin State',
				value: QUOTE.ORIGIN_STATE,
				sample: 'California',
			},
			quote_origin_postcode: {
				name: 'Origin Postcode',
				value: QUOTE.ORIGIN_POSTCODE,
				sample: '12345',
			},
			quote_destination_city: {
				name: 'Destination City',
				value: QUOTE.DESTINATION_CITY,
				sample: 'Dallas',
			},
			quote_destination_state: {
				name: 'Destination State',
				value: QUOTE.DESTINATION_STATE,
				sample: 'Texas',
			},
			quote_destination_postcode: {
				name: 'Destination Postcode',
				value: QUOTE.DESTINATION_POSTCODE,
				sample: '12345',
			},
			quote_equipments: {
				name: 'Equipments',
				value: QUOTE.EQUIPMENTS,
				sample: 'Van',
			},
			quote_commodity: {
				name: 'Commodity',
				value: QUOTE.COMMODITY,
				sample: 'Apples',
			},
			quote_trailer_length: {
				name: 'Trailer Length',
				value: QUOTE.TRAILER_LENGTH,
				sample: '(53 ft)',
			},
			quote_min_temperature: {
				name: 'Min Temperature',
				value: QUOTE.MIN_TEMPERATURE,
				sample: '45',
			},
			quote_max_temperature: {
				name: 'Max Temperature',
				value: QUOTE.MAX_TEMPERATURE,
				sample: '90',
			},
			quote_temperature: {
				name: 'Temperature',
				value: QUOTE.TEMPERATURE,
				sample: '45° F to 90° F',
			},
			quote_tarp_size: {
				name: 'Tarp Size',
				value: QUOTE.TARP_SIZE,
				sample: '8',
			},
			quote_declared_value: {
				name: 'Declared Value',
				value: QUOTE.DECLARED_VALUE,
				sample: '1234',
			},
			quote_pickup_date: {
				name: 'Pickup Date',
				value: QUOTE.PICKUP_DATE,
				sample: 'December 31',
			},
			quote_pickup_open_time: {
				name: 'Pickup Open Time',
				value: QUOTE.PICKUP_OPEN_TIME,
				sample: '08:00',
			},
			quote_pickup_close_time: {
				name: 'Pickup Close Time',
				value: QUOTE.PICKUP_CLOSE_TIME,
				sample: '20:00',
			},
			quote_pickup_time: {
				name: 'Pickup Time',
				value: '{{quotePickupTime}}',
				sample: '08:00 - 20:00',
			},
			quote_pickup_appointment_required: {
				name: 'Pickup Appointment Required',
				value: QUOTE.PICKUP_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_delivery_date: {
				name: 'Delivery Date',
				value: QUOTE.DELIVERY_DATE,
				sample: 'January 1',
			},
			quote_delivery_open_time: {
				name: 'Delivery Open Time',
				value: QUOTE.DELIVERY_OPEN_TIME,
				sample: '08:00',
			},
			quote_delivery_close_time: {
				name: 'Delivery Close Time',
				value: QUOTE.DELIVERY_CLOSE_TIME,
				sample: '20:00',
			},
			quote_delivery_time: {
				name: 'Delivery Time',
				value: '{{quoteDeliveryTime}}',
				sample: '08:00 - 20:00',
			},
			quote_delivery_appointment_required: {
				name: 'Delivery Appointment Required',
				value: QUOTE.DELIVERY_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_weight: {
				name: 'Weight',
				value: QUOTE.WEIGHT,
				sample: '123',
			},
			quote_declared_price: {
				name: 'Offer Price',
				value: QUOTE.DECLARED_PRICE,
				sample: '1234',
			},
			quote_stops: {
				name: 'Stops',
				value: QUOTE.STOPS,
				sample: '1',
			},
			quote_team_service_required: {
				name: 'Team Service Required',
				value: QUOTE.TEAM_SERVICE_REQUIRED,
				sample: 'Yes',
			},
			quote_special_instructions: {
				name: 'Special Instructions',
				value: QUOTE.SPECIAL_INSTRUCTIONS,
				sample: 'Handle with care',
			},
			quote_pieces: {
				name: 'Pieces',
				value: QUOTE.PIECES,
				sample: '2',
			},
			quote_partial_load: {
				name: 'Partial Load',
				value: QUOTE.PARTIAL_LOAD,
				sample: 'Yes',
			},
			quote_linear_feet: {
				name: 'Linear Feet',
				value: QUOTE.LINEAR_FEET,
				sample: '20',
			},
			quote_po_number: {
				name: 'PO Number',
				value: QUOTE.PO_NUMBER,
				sample: 'PO12345',
			},
			quote_order_type: {
				name: 'Order Type',
				value: QUOTE.ORDER_TYPE,
				sample: 'Outbound',
			},
		},
	},
	bid: {
		name: 'Bid',
		mergeTags: {
			bid_pickup_date: {
				name: 'Pickup Date',
				value: BID.PICKUP_DATE,
				sample: 'December 31',
			},
			bid_delivery_date: {
				name: 'Delivery Date',
				value: BID.DELIVERY_DATE,
				sample: 'January 1',
			},
		},
	},
	batch: {
		name: 'Batch',
		mergeTags: {
			max_weight: {
				name: 'Max weight',
				value: '{{maxWeight}}',
				sample: '1000',
			},
			delivery_date_range: {
				name: 'Delivery Date Range',
				value: '{{deliveryDateRange}}',
				sample: 'December 31 - Jan 5',
			},
			pickup_date_range: {
				name: 'Pickup Date Range',
				value: '{{pickupDateRange}}',
				sample: 'Jan 1 - Jan 6',
			},
			load_offer_range: {
				name: 'Offer Price Range',
				value: '{{loadOfferRange}}',
				sample: '1100 - 1250',
			},
			load_count: {
				name: 'Load Count',
				value: '{{loadCount}}',
				sample: 5,
			},
			load_reference_numbers: {
				name: 'Load Reference Numbers',
				value: '{{loadReferenceNumbers}}',
				sample: 'Ref123456, Ref654321',
			},
		},
	},
	offer_link: {
		name: 'Offer Link',
		value: BATCH_OFFER_LINK,
		sample: BATCH_OFFER_LINK,
	},
	is_quote_temperature_available: {
		name: 'Is Quote Temperature Available',
		value: '{{isQuoteTemperatureAvailable}}',
		sample: 'true',
	},
	is_quote_declared_value_gt_threshold: {
		name: 'Is Declared Value Greater Than Threshold',
		value: '{{isQuoteDeclaredValueGtThreshold}}',
		sample: 'true',
	},
	is_quote_order_type_available: {
		name: 'Is Order Type Available',
		value: '{{isQuoteOrderTypeAvailable}}',
		sample: 'true',
	},
};

export const MERGE_TAGS_COUNTER_OFFER = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
			user_mc: {
				name: 'MC',
				value: USER.MC,
				sample: '123456',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
		},
	},
	quote: {
		name: 'Load',
		mergeTags: {
			quote_origin_city: {
				name: 'Origin City',
				value: QUOTE.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			quote_origin_state: {
				name: 'Origin State',
				value: QUOTE.ORIGIN_STATE,
				sample: 'California',
			},
			quote_origin_postcode: {
				name: 'Origin Postcode',
				value: QUOTE.ORIGIN_POSTCODE,
				sample: '12345',
			},
			quote_destination_city: {
				name: 'Destination City',
				value: QUOTE.DESTINATION_CITY,
				sample: 'Dallas',
			},
			quote_destination_state: {
				name: 'Destination State',
				value: QUOTE.DESTINATION_STATE,
				sample: 'Texas',
			},
			quote_destination_postcode: {
				name: 'Destination Postcode',
				value: QUOTE.DESTINATION_POSTCODE,
				sample: '12345',
			},
			quote_equipments: {
				name: 'Equipments',
				value: QUOTE.EQUIPMENTS,
				sample: 'Van',
			},
			quote_weight: {
				name: 'Weight',
				value: QUOTE.WEIGHT,
				sample: '123',
			},
			quote_approximate_miles: {
				name: 'Approximate Miles',
				value: QUOTE.APPROXIMATTE_MILES,
				sample: '123',
			},
			quote_commodity: {
				name: 'Commodity',
				value: QUOTE.COMMODITY,
				sample: 'Apples',
			},
			quote_tarp_size: {
				name: 'Tarp Size',
				value: QUOTE.TARP_SIZE,
				sample: '8',
			},
			quote_min_temperature: {
				name: 'Min Temperature',
				value: QUOTE.MIN_TEMPERATURE,
				sample: '45',
			},
			quote_max_temperature: {
				name: 'Max Temperature',
				value: QUOTE.MAX_TEMPERATURE,
				sample: '90',
			},
			quote_temperature: {
				name: 'Temperature',
				value: QUOTE.TEMPERATURE,
				sample: '45° F to 90° F',
			},
			quote_declared_value: {
				name: 'Declared Value',
				value: QUOTE.DECLARED_VALUE,
				sample: '1234',
			},
			quote_pickup_date: {
				name: 'Pickup Date',
				value: QUOTE.PICKUP_DATE,
				sample: 'December 31',
			},
			quote_pickup_open_time: {
				name: 'Pickup Open Time',
				value: QUOTE.PICKUP_OPEN_TIME,
				sample: '08:00',
			},
			quote_pickup_close_time: {
				name: 'Pickup Close Time',
				value: QUOTE.PICKUP_CLOSE_TIME,
				sample: '20:00',
			},
			quote_pickup_appointment_required: {
				name: 'Pickup Appointment Required',
				value: QUOTE.PICKUP_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_delivery_date: {
				name: 'Delivery Date',
				value: QUOTE.DELIVERY_DATE,
				sample: 'January 1',
			},
			quote_delivery_open_time: {
				name: 'Delivery Open Time',
				value: QUOTE.DELIVERY_OPEN_TIME,
				sample: '08:00',
			},
			quote_delivery_close_time: {
				name: 'Delivery Close Time',
				value: QUOTE.DELIVERY_CLOSE_TIME,
				sample: '20:00',
			},
			quote_delivery_appointment_required: {
				name: 'Delivery Appointment Required',
				value: QUOTE.DELIVERY_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_team_service_required: {
				name: 'Team Service Required',
				value: QUOTE.TEAM_SERVICE_REQUIRED,
				sample: 'Yes',
			},
			quote_special_instructions: {
				name: 'Special Instructions',
				value: QUOTE.SPECIAL_INSTRUCTIONS,
				sample: 'Handle with care',
			},
			quote_declared_price: {
				name: 'Offer Price',
				value: QUOTE.DECLARED_PRICE,
				sample: '1234',
			},
			quote_order_type: {
				name: 'Order Type',
				value: QUOTE.ORDER_TYPE,
				sample: 'Outbound',
			},
		},
	},
	counter_offer: {
		name: 'Counter Offer',
		mergeTags: {
			counter_offer_offer_amount: {
				name: 'Offer Amount',
				value: COUNTER_OFFER.OFFER_AMOUNT,
				sample: '1234',
			},
			counter_offer_pickup_date: {
				name: 'Pickup Date',
				value: COUNTER_OFFER.PICKUP_DATE,
				sample: 'December 31',
			},
			counter_offer_delivery_date: {
				name: 'Delivery Date',
				value: COUNTER_OFFER.DELIVERY_DATE,
				sample: 'January 1',
			},
		},
	},
	bid: {
		name: 'Bid',
		mergeTags: {
			bid_pickup_date: {
				name: 'Pickup Date',
				value: BID.PICKUP_DATE,
				sample: 'December 31',
			},
			bid_delivery_date: {
				name: 'Delivery Date',
				value: BID.DELIVERY_DATE,
				sample: 'January 1',
			},
		},
	},
	latest_carrier_amount: {
		name: 'Latest Carrier Amount',
		value: LATEST_CARRIER_AMOUNT,
		sample: '1234',
	},
	is_quote_declared_value_gt_threshold: {
		name: 'Is Declared Value Greater Than Threshold',
		value: '{{isQuoteDeclaredValueGtThreshold}}',
		sample: 'true',
	},
	is_quote_temperature_available: {
		name: 'Is Quote Temperature Available',
		value: '{{isQuoteTemperatureAvailable}}',
		sample: 'true',
	},
	is_source_type_carrier: {
		name: 'Is Source Type Carrier',
		value: '{{sourceTypeCarrier}}',
		sample: 'true',
	},
	is_source_type_customer: {
		name: 'Is Source Type Customer',
		value: '{{sourceTypeCustomer}}',
		sample: 'false',
	},
	is_quote_order_type_available: {
		name: 'Is Order Type Available',
		value: '{{isQuoteOrderTypeAvailable}}',
		sample: 'true',
	},
};

export const MERGE_TAGS_ACCEPT_OFFER = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
			user_system_name: {
				name: 'System Name',
				value: USER.SYSTEM_NAME,
				sample: 'XYZ System',
			},
			user_mc: {
				name: 'MC',
				value: USER.MC,
				sample: '123456',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
		},
	},
	quote: {
		name: 'Load',
		mergeTags: {
			quote_origin_city: {
				name: 'Origin City',
				value: QUOTE.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			quote_origin_state: {
				name: 'Origin State',
				value: QUOTE.ORIGIN_STATE,
				sample: 'California',
			},
			quote_origin_postcode: {
				name: 'Origin Postcode',
				value: QUOTE.ORIGIN_POSTCODE,
				sample: '12345',
			},
			quote_destination_city: {
				name: 'Destination City',
				value: QUOTE.DESTINATION_CITY,
				sample: 'Dallas',
			},
			quote_destination_state: {
				name: 'Destination State',
				value: QUOTE.DESTINATION_STATE,
				sample: 'Texas',
			},
			quote_destination_postcode: {
				name: 'Destination Postcode',
				value: QUOTE.DESTINATION_POSTCODE,
				sample: '12345',
			},
			quote_equipments: {
				name: 'Equipments',
				value: QUOTE.EQUIPMENTS,
				sample: 'Van',
			},
			quote_pickup_date: {
				name: 'Pickup Date',
				value: QUOTE.PICKUP_DATE,
				sample: 'December 31',
			},
			quote_pickup_open_time: {
				name: 'Pickup Open Time',
				value: QUOTE.PICKUP_OPEN_TIME,
				sample: '08:00',
			},
			quote_pickup_close_time: {
				name: 'Pickup Close Time',
				value: QUOTE.PICKUP_CLOSE_TIME,
				sample: '20:00',
			},
			quote_delivery_date: {
				name: 'Delivery Date',
				value: QUOTE.DELIVERY_DATE,
				sample: 'January 1',
			},
			quote_delivery_open_time: {
				name: 'Delivery Open Time',
				value: QUOTE.DELIVERY_OPEN_TIME,
				sample: '08:00',
			},
			quote_delivery_close_time: {
				name: 'Delivery Close Time',
				value: QUOTE.DELIVERY_CLOSE_TIME,
				sample: '20:00',
			},
			quote_weight: {
				name: 'Weight',
				value: QUOTE.WEIGHT,
				sample: '123',
			},
			quote_approximate_miles: {
				name: 'Approximate Miles',
				value: QUOTE.APPROXIMATTE_MILES,
				sample: '123',
			},
			quote_commodity: {
				name: 'Commodity',
				value: QUOTE.COMMODITY,
				sample: 'Apples',
			},
			quote_tarp_size: {
				name: 'Tarp Size',
				value: QUOTE.TARP_SIZE,
				sample: '8',
			},
			quote_special_instructions: {
				name: 'Special Instructions',
				value: QUOTE.SPECIAL_INSTRUCTIONS,
				sample: 'Handle with care',
			},
			quote_team_service_required: {
				name: 'Team Service Required',
				value: QUOTE.TEAM_SERVICE_REQUIRED,
				sample: 'Yes',
			},
			quote_pickup_appointment_required: {
				name: 'Pickup Appointment Required',
				value: QUOTE.PICKUP_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_delivery_appointment_required: {
				name: 'Delivery Appointment Required',
				value: QUOTE.DELIVERY_APPOINTMENT_REQUIRED,
				sample: 'Appointment Needed',
			},
			quote_order_type: {
				name: 'Order Type',
				value: QUOTE.ORDER_TYPE,
				sample: 'Outbound',
			},
		},
	},
	bid: {
		name: 'Bid',
		mergeTags: {
			bid_amount: {
				name: 'Bid Amount',
				value: BID.AMOUNT,
				sample: '1234',
			},
			bid_pickup_date: {
				name: 'Pickup Date',
				value: BID.PICKUP_DATE,
				sample: 'December 31',
			},
		},
	},
	or_phone: {
		name: 'or Phone',
		value: '{{or user.phoneNumber}}',
		sample: ' or 123-456-7890',
	},
	is_quote_order_type_available: {
		name: 'Is Order Type Available',
		value: '{{isQuoteOrderTypeAvailable}}',
		sample: 'true',
	},
};

export const MERGE_TAGS_CHECK_CAPACITY = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
			hey_contact_first_name: {
				name: 'Hey First Name',
				value: '{{Hey contact.firstName}}',
				sample: 'Hey John',
			},
		},
	},
	project: {
		name: 'Load',
		mergeTags: {
			project_equipment_type: {
				name: 'Equipment Type',
				value: PROJECT.EQUIPMENT_TYPE,
				sample: 'Van',
			},
			project_origin_city: {
				name: 'Origin City',
				value: PROJECT.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			project_origin_state: {
				name: 'Origin State',
				value: PROJECT.ORIGIN_STATE,
				sample: 'California',
			},
			project_destination_city: {
				name: 'Destination City',
				value: PROJECT.DESTINATION_CITY,
				sample: 'Dallas',
			},
			project_destination_state: {
				name: 'Destination State',
				value: PROJECT.DESTINATION_STATE,
				sample: 'Texas',
			},
			project_commodity: {
				name: 'Commodity',
				value: PROJECT.COMMODITY,
				sample: 'Apples',
			},
			project_trailer_requirements: {
				name: 'Trailer Requirements',
				value: PROJECT.TRAILER_REQUIREMENTS,
				sample: 'No holes',
			},
			project_due_date: {
				name: 'Due Date',
				value: PROJECT.DUE_DATE,
				sample: 'December 31',
			},
			project_shipper_notes: {
				name: 'Shipper Notes',
				value: PROJECT.SHIPPER_NOTES,
				sample: 'Appointment needed',
			},
			project_receiver_notes: {
				name: 'Receiver Notes',
				value: PROJECT.RECEIVER_NOTES,
				sample: 'Appointment needed',
			},
			project_project_weight: {
				name: 'Weight',
				value: PROJECT.WEIGHT,
				sample: '123',
			},
			project_packaging: {
				name: 'Packaging',
				value: PROJECT.PACKAGING,
				sample: 'Packaging',
			},
		},
	},
	annual_volume_value: {
		name: 'Annual Volume Value',
		value: ANNUAL_VOLUME_VALUE,
		sample: '123/year',
	},
};

export const MERGE_TAGS_EMAIL_SIGNATURE = {
	user_first_name: {
		name: 'First Name',
		value: USER.FIRST_NAME,
		sample: 'Jane',
	},
	user_last_name: {
		name: 'Last Name',
		value: USER.LAST_NAME,
		sample: 'Doe',
	},
	user_phone: {
		name: 'Phone',
		value: USER.PHONE,
		sample: '123-456-7890',
	},
	user_email: {
		name: 'Email',
		value: USER.EMAIL,
		sample: 'user@email.com',
	},
	user_business_name: {
		name: 'Business Name',
		value: USER.BUSINESS_NAME,
		sample: 'XYZ Brokerage',
	},
};

export const MERGE_TAGS_TEST_VALUES = {
	user_first_name: 'Jane',
	user_last_name: 'Doe',
	user_phone: '123-456-7890',
	user_email: 'user@email.com',
	user_business_name: 'XYZ Brokerage',
	user_system_name: 'XYZ System',
	user_mc: '123456',

	contact_first_name: 'John',
	contact_last_name: 'Doe',
	hey_contact_first_name: 'Hey John',

	carrier_business_name: 'XYZ Carrier',
	carrier_mc: '123456',
	carrier_dot: '123456',

	quote_reference_number: 'Ref123456',
	quote_trailer_length: '(53 ft)',
	quote_declared_value: '1234',
	quote_declared_price: '1234',
	quote_origin_city: 'San Francisco',
	quote_origin_state: 'California',
	quote_origin_postcode: '12345',
	quote_destination_city: 'Dallas',
	quote_destination_state: 'Texas',
	quote_destination_postcode: '12345',
	quote_equipments: 'Van',
	quote_pickup_date: 'December 31',
	quote_pickup_open_time: '08:00',
	quote_pickup_close_time: '20:00',
	quote_pickup_time: '08:00 - 20:00',
	quote_delivery_date: 'January 1',
	quote_delivery_open_time: '08:00',
	quote_delivery_close_time: '20:00',
	quote_delivery_time: '08:00 - 20:00',
	quote_weight: '123',
	quote_approximate_miles: '123',
	quote_commodity: 'Apples',
	quote_tarp_size: '8',
	quote_special_instructions: 'Handle with care',
	quote_min_temperature: '45',
	quote_max_temperature: '90',
	quote_stops: '2',
	quote_team_service_required: 'Yes',
	quote_pickup_appointment_required: 'Appointment Needed',
	quote_delivery_appointment_required: 'Appointment Needed',
	quote_temperature: '45° F to 90° F',
	quote_pieces: '2',
	quote_partial_load: 'Yes',
	quote_linear_feet: '20',
	quote_order_type: 'Outbound',

	counter_offer_offer_amount: '1234',
	counter_offer_pickup_date: 'December 31',
	counter_offer_delivery_date: 'January 1',

	bid_amount: '1234',
	bid_pickup_date: 'December 31',
	bid_delivery_date: 'January 1',

	project_equipment_type: 'Van',
	project_origin_city: 'San Francisco',
	project_origin_state: 'California',
	project_destination_city: 'Dallas',
	project_destination_state: 'Texas',
	project_commodity: 'Apples',
	project_due_date: 'December 31',
	project_trailer_requirements: 'No holes',
	project_shipper_notes: 'Appointment Needed',
	project_receiver_notes: 'Appointment Needed',
	project_project_weight: '123',
	project_packaging: 'Packaging',

	annual_volume_value: '123/year',
	latest_carrier_amount: '1234',
	offer_link: OFFER_LINK,

	or_phone: ' or 123-456-7890',
	is_quote_declared_value_gt_threshold: 'true',
	is_quote_temperature_available: 'true',
	is_source_type_carrier: 'true',
	is_source_type_customer: 'false',
	is_quote_order_type_available: 'true',
	load_count: 5,

	lane: 'San Francisco, CA → Dallas, TX (VAN)',
};

export const EDITOR_OPTIONS = {
	tabs: {
		body: {
			active: true,
			position: 1,
		},
		content: {
			enabled: true,
			position: 2,
		},
		blocks: {
			enabled: true,
			position: 3,
		},
	},
	fonts: {
		showDefaultFonts: false,
	},
	tools: {
		image: {
			enabled: false,
		},
		button: {
			enabled: true,
		},
		menu: {
			enabled: false,
		},
		html: {
			enabled: false,
		},
	},
	specialLinks: [
		{
			name: 'Offer Link',
			href: OFFER_LINK,
			target: OFFER_LINK,
		},
	],
	mergeTagsConfig: {
		sort: false,
	},
	features: {
		textEditor: {
			emojis: false,
		},
		preview: true,
		preheaderText: false,
		stockImages: {
			enabled: false,
		},
	},
	projectId: 80552,
};

export const EDITOR_OPTIONS_SIGNATURE = {
	tabs: {
		body: {
			active: true,
			position: 1,
		},
		content: {
			enabled: false,
		},
		blocks: {
			enabled: true,
			position: 2,
		},
	},
	fonts: {
		showDefaultFonts: false,
	},
	tools: {
		image: {
			enabled: false,
		},
		button: {
			enabled: false,
		},
		menu: {
			enabled: false,
		},
		html: {
			enabled: false,
		},
	},
	mergeTagsConfig: {
		sort: false,
	},
	features: {
		textEditor: {
			emojis: false,
		},
		preview: true,
		preheaderText: false,
		stockImages: {
			enabled: false,
		},
	},
	projectId: 80552,
};

export const TEST_EMAIL_DATA = {
	'quote.originState': 'CA',
	'quote.destinationState': 'TX',
	'quote.referenceNumber': 'Ref123456',
	'projectDTO.originState': 'CA',
	'projectDTO.destState': 'TX',
	'projectDTO.name': 'San Francisco, CA → Dallas, TX (VAN)',
	'truck.originCity': 'San Francisco',
	'truck.originState': 'CA',
	'user.businessName': 'XYZ Brokerage',
	loadCount: 5,
};

export const LANE = '{{lane}}';

export const MERGE_TAGS_PROCURED_CARRIER = {
	user: {
		name: 'User',
		mergeTags: {
			user_first_name: {
				name: 'First Name',
				value: USER.FIRST_NAME,
				sample: 'Jane',
			},
			user_last_name: {
				name: 'Last Name',
				value: USER.LAST_NAME,
				sample: 'Doe',
			},
			user_phone: {
				name: 'Phone',
				value: USER.PHONE,
				sample: '123-456-7890',
			},
			user_email: {
				name: 'Email',
				value: USER.EMAIL,
				sample: 'user@email.com',
			},
			user_business_name: {
				name: 'Business Name',
				value: USER.BUSINESS_NAME,
				sample: 'XYZ Brokerage',
			},
		},
	},
	contact: {
		name: 'Contact',
		mergeTags: {
			contact_first_name: {
				name: 'First Name',
				value: '{{contact.firstName}}',
				sample: 'John',
			},
			contact_last_name: {
				name: 'Last Name',
				value: '{{contact.lastName}}',
				sample: 'Doe',
			},
			hey_contact_first_name: {
				name: 'Hey First Name',
				value: '{{Hey contact.firstName}}',
				sample: 'Hey John',
			},
		},
	},
	project: {
		name: 'Project',
		mergeTags: {
			project_equipment_type: {
				name: 'Equipment Type',
				value: PROJECT.EQUIPMENT_TYPE,
				sample: 'Van',
			},
			project_origin_city: {
				name: 'Origin City',
				value: PROJECT.ORIGIN_CITY,
				sample: 'San Francisco',
			},
			project_origin_state: {
				name: 'Origin State',
				value: PROJECT.ORIGIN_STATE,
				sample: 'California',
			},
			project_destination_city: {
				name: 'Destination City',
				value: PROJECT.DESTINATION_CITY,
				sample: 'Dallas',
			},
			project_destination_state: {
				name: 'Destination State',
				value: PROJECT.DESTINATION_STATE,
				sample: 'Texas',
			},
			project_commodity: {
				name: 'Commodity',
				value: PROJECT.COMMODITY,
				sample: 'Apples',
			},
			project_trailer_requirements: {
				name: 'Trailer Requirements',
				value: PROJECT.TRAILER_REQUIREMENTS,
				sample: 'No holes',
			},
			project_due_date: {
				name: 'Due Date',
				value: PROJECT.DUE_DATE,
				sample: 'December 31',
			},
			project_shipper_notes: {
				name: 'Shipper Notes',
				value: PROJECT.SHIPPER_NOTES,
				sample: 'Appointment needed',
			},
			project_receiver_notes: {
				name: 'Receiver Notes',
				value: PROJECT.RECEIVER_NOTES,
				sample: 'Appointment needed',
			},
			project_project_weight: {
				name: 'Weight',
				value: PROJECT.WEIGHT,
				sample: '123',
			},
			project_packaging: {
				name: 'Packaging',
				value: PROJECT.PACKAGING,
				sample: 'Packaging',
			},
			project_name: {
				name: 'Name',
				value: PROJECT.NAME,
				sample: 'San Francisco, CA → Dallas, TX (VAN)',
			},
		},
	},
	annual_volume_value: {
		name: 'Annual Volume Value',
		value: ANNUAL_VOLUME_VALUE,
		sample: '123/year',
	},
	lane: {
		name: 'Lane',
		value: LANE,
		sample: 'San Francisco, CA → Dallas, TX (VAN)',
	},
};
